module.exports = __webpack_public_path__ + "static/img/yh.7e59b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userVal/yh.png
// module id = zCRu
// module chunks = 0